import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var laptopIcon = /*#__PURE__*/React.createElement("svg", {
  height: "14",
  width: "16",
  viewBox: "0 0 16 14",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.167.5a1 1 0 0 1 .995.904l.005.096v8.833h-1V1.5H1.787v8.833h-1V1.5a1 1 0 0 1 .904-.995L1.788.5h12.379Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 10.302v2.167c0 .644-.522 1.167-1.167 1.167H1.167A1.167 1.167 0 0 1 0 12.469v-2.167h16Zm-1 1H1v1.167c0 .079.055.145.128.162l.039.005h13.666a.167.167 0 0 0 .163-.129L15 12.47v-1.167Z"
})));

export { laptopIcon as default };
//# sourceMappingURL=laptopIcon.js.map
